<div class="w-100">
  <div>
    <mwp-card-content-header [url]="apiUrl" />
  </div>
  <div class="row">
    <div class="col-6">
      @if (ptoForm) {
        <form [formGroup]="ptoForm" autocomplete="off">
          <div class="content-container form-comp mb-4">
            <div class="title">
              <mwp-text-translate text="Paid Time Off - Year to Date" jsonKey="ptoYTD" />
            </div>
            <div class="row content">
              <div class=" col-4 mb-4">
                <mwp-input [form]="ptoForm" labelName="Hours Available" nameForControl="ptoHoursAvailable" />
              </div>
              <div class="col-4 mb-4">
                <mwp-input [form]="ptoForm" labelName="Hours Accrued" nameForControl="ptoHoursAccrued" />
              </div>
              <div class="col-4 mb-4">
                <mwp-input [form]="ptoForm" labelName="Hours Spent" nameForControl="ptoHoursSpent" />
              </div>
            </div>
          </div>
        </form>
      }
    </div>
    <div class="col-6">
       @if (sickLeaveForm) {
        <form [formGroup]="sickLeaveForm" autocomplete="off">
          <div class="content-container form-comp">
            <div class="title">
              <mwp-text-translate text="Sick Hours - Year to Date" jsonKey="sickLeaveYTD" />
            </div>
            <div class="row content">
              <div class=" col-4 mb-4">
                <mwp-input [form]="sickLeaveForm" labelName="Hours Available" nameForControl="sickLeaveHoursAvailable" />
              </div>
              <div class="col-4 mb-4">
                <mwp-input [form]="sickLeaveForm" labelName="Hours Accrued" nameForControl="sickLeaveHoursAccrued" />
              </div>
              <div class="col-4 mb-4">
                <mwp-input [form]="sickLeaveForm" labelName="Hours Spent" nameForControl="sickLeaveHoursSpent" />
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>